import Navbar from '../navbar/Navbar'
import './profile.css'

export default function Profile() {
  return (
    <div className='pcntr bor'>
        <Navbar />
        <div className='fbpcntr bor'>
        {/* --------------background profile image----------------- */}
            <div className='bgimg'>
              <img src='https://upload.wikimedia.org/wikipedia/en/6/62/Knowhere%2C_as_depicted_in_the_2014_film_Guardians_of_the_Galaxy.png' alt='profile-bgimage' />
              <div className='psqare'>
                <img src='https://besthqwallpapers.com/Uploads/19-8-2018/62142/thumb2-chris-pratt-hollywood-star-american-actor-photoshoot-portrait.jpg' alt='profile' />
                <div className='pstatus'>
                  <div className='pofstatus'></div>
                </div>
              </div>
            </div>
        {/* --------------pdetails----------------- */}
            <div className='pnamehere'>
                <h3>Your Name Is Here</h3>
                <p>UX designer . Paris, France</p>
            </div>
            <div className='pintro'>
                <h3>Intro</h3>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                Lorem Ipsum has been the industry's standard dummy text ever since the</p>
            </div>
            <div className='pintro'>
                <h3>Photos</h3>
                <div className='pphotos1'>
                    <img src='https://images6.fanpop.com/image/photos/40100000/Chris-Pratt-Vanity-Fair-Photoshoot-November-2016-chris-pratt-40157369-1484-2000.jpg' alt='picname' />
                    <img src='https://terrigen-cdn-dev.marvel.com/content/prod/1x/021slq_ons_mas_mob_01_0.jpg' alt='picname' />
                    <img src='https://media.gq.com/photos/560846c9bfd713e857b2d7b8/master/pass/style-2014-12-chris-pratt-1415381955195_chris-pratt-gq-magazine-december-2014-moty-03.jpg' alt='picname' />
                    <div className='ppcards bor pplastcard'>+125</div>
                </div>
            </div>
            <div className='pintro'>
                <h3>Friends</h3>
                <div className='pphotos1'>
                    <img src='https://images6.fanpop.com/image/photos/40100000/Chris-Pratt-Vanity-Fair-Photoshoot-November-2016-chris-pratt-40157369-1484-2000.jpg' alt='picname' />
                    <img src='https://terrigen-cdn-dev.marvel.com/content/prod/1x/021slq_ons_mas_mob_01_0.jpg' alt='picname' />
                    <img src='https://media.gq.com/photos/560846c9bfd713e857b2d7b8/master/pass/style-2014-12-chris-pratt-1415381955195_chris-pratt-gq-magazine-december-2014-moty-03.jpg' alt='picname' />
                    <div className='ppcards bor pplastcard1'>+961</div>
                </div>
            </div>
  {/* --------------end pdetails----------------- */}

        </div>
    </div>
  )
}
